// Etiquetas para las capacitaciones en diferentes idiomas
export const capacitacionesLabels = {
  espanol: {
    horario: "Horario",
    fecha: "Fecha", 
    ubicacion: "Ubicación",
    inscribirse: "Inscríbete",
    idioma: "Idioma",
    marca: "Marca",
    responsable: "Responsable"
  },
  ingles: {
    horario: "Schedule",
    fecha: "Date",
    ubicacion: "Location", 
    inscribirse: "Register",
    idioma: "Language",
    marca: "Brand",
    responsable: "Responsible"
  }
};

// Función para obtener las etiquetas según el idioma
export const getLabels = (idioma) => {
  return capacitacionesLabels[idioma] || capacitacionesLabels.espanol; // Fallback a español
};

// Función para obtener el nombre del idioma en su propio idioma
export const getLanguageName = (idioma) => {
  const languageNames = {
    espanol: "Español",
    ingles: "English"
  };
  return languageNames[idioma] || idioma;
};
